import React from 'react';
import { render } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import { Checkbox } from './Checkbox';

describe('Checkbox', () => {
	const user = userEvent.setup();

	beforeEach(() => jest.spyOn(console, 'error'));

	it('should be checked on click', async () => {
		const { getByLabelText } = render(<Checkbox label="Label" />);
		const checkbox = getByLabelText('Label') as HTMLInputElement;

		expect(checkbox.checked).toEqual(false);
		await user.click(checkbox);
		expect(checkbox.checked).toEqual(true);
	});

	it('should return object on change', async () => {
		const onChangeTest = jest.fn();
		const { getByLabelText } = render(
			<Checkbox onChange={onChangeTest} value="test" label="Label" />
		);
		const checkbox = getByLabelText('Label') as HTMLInputElement;

		await user.click(checkbox);
		expect(onChangeTest).toBeCalledWith('test', true, expect.any(Object));
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Checkbox label="Label" data-auto-sel="automation-selector" />
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
